__turbopack_context__.v({
  "content": "Authorization-module-scss-module__DnfyOG__content",
  "content__auth_methods": "Authorization-module-scss-module__DnfyOG__content__auth_methods",
  "hidden": "Authorization-module-scss-module__DnfyOG__hidden",
  "root": "Authorization-module-scss-module__DnfyOG__root",
});
